import React, { FC } from "react";
import { usePushNotificationDao } from "./usePushNotificationDao";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { UserSubscriptionsDto } from "./UserSubscriptions";

export interface SubscriptionsLoaderProps {
  children: (result: UseQueryResult<UserSubscriptionsDto>) => React.ReactNode;
}

export const PushNotificationSubscriptionsLoader: FC<
  SubscriptionsLoaderProps
> = (props) => {
  const dao = usePushNotificationDao();
  const result = useQuery({
    queryKey: ["PushNotificationDao.getSubscriptions"],
    queryFn: () => dao.getSubscriptions(),
    enabled: true,
    staleTime: 10 * 1000,
    gcTime: 15 * 1000,
  });
  return props.children(result);
};
